"use client";

import { LinkWhatsApp } from "@/components/UI/LinkWhatsApp";
import { WhatsAppIcon } from "@/components/UI/SocialIcons";
import { STORE_INFO } from "@/lib/constants/storeInfo";

/** "Não encontrou? Fale com a gente no WhatsApp", já com o termo buscado na mensagem. */
export function SearchWhatsAppButton({ term, position }: { term: string; position: string }) {
  const cleanTerm = term.trim().slice(0, 100);
  const message = cleanTerm
    ? `Olá! Procurei por "${cleanTerm}" no site e não encontrei. Vocês têm?`
    : "Olá! Não encontrei um produto no site. Podem me ajudar?";
  return (
    <LinkWhatsApp
      posicao={position}
      fallbackHref={STORE_INFO.whatsapp.href}
      mensagem={message}
      className="inline-flex h-10 items-center gap-2 rounded-xl bg-[#25D366] px-4 text-sm font-semibold text-white transition-colors hover:bg-[#1fb958] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
    >
      <WhatsAppIcon className="h-5 w-5 shrink-0" aria-hidden="true" />
      Não encontrou? Fale com a gente no WhatsApp
    </LinkWhatsApp>
  );
}
